export const GET_CLIENTS = 'GET_CLIENTS' 
export const GET_CLIENTS_SUCCESS = 'GET_CLIENTS_SUCCESS' 
export const ADD_CLIENTS = 'ADD_CLIENTS' 
export const ADD_CLIENTS_SUCCESS = 'ADD_CLIENTS_SUCCESS' 